<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                            <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessage.length > 0" v-for="(error, key) in errorMessage" :key="error">
                                <span>{{error}}</span>
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError(key)">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="list-setting-component">
                        <div class="col-sm-12 d-flex gap-3 flex-wrap flex-column">
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataSettingFile.name.label"
                                        :id="dataSettingFile.name.id"
                                        :placeholder="dataSettingFile.name.placeholder"
                                        :value-default="dataSettingFile.name.value"
                                        @inputValue="onChange($event, dataSettingFile.name.id)"
                                        :error-text="dataSettingFile.name.error"
                                        :is-error="dataSettingFile.name.isError"
                                        @blur="validateForm($event, dataSettingFile.name.id)"
                                        :required="dataSettingFile.name.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <SelectNormal
                                        :label="dataSettingFile.table_use.label"
                                        :id="dataSettingFile.table_use.id"
                                        :placeholder="dataSettingFile.table_use.placeholder"
                                        :value-default="dataSettingFile.table_use.value"
                                        @inputValue="onChange($event, dataSettingFile.table_use.id)"
                                        :error-text="dataSettingFile.table_use.error"
                                        :is-error="dataSettingFile.table_use.isError"
                                        @blur="validateForm($event, dataSettingFile.table_use.id)"
                                        :required="dataSettingFile.table_use.required"
                                        :options="dataSettingFile.table_use.options"
                                ></SelectNormal>
                            </div>
                            <div class="col-sm-4">
                                <SelectNormal
                                        :label="dataSettingFile.type.label"
                                        :id="dataSettingFile.type.id"
                                        :placeholder="dataSettingFile.type.placeholder"
                                        :value-default="dataSettingFile.type.value"
                                        @inputValue="onChange($event, dataSettingFile.type.id)"
                                        :error-text="dataSettingFile.type.error"
                                        :is-error="dataSettingFile.type.isError"
                                        @blur="validateForm($event, dataSettingFile.type.id)"
                                        :required="dataSettingFile.type.required"
                                        :options="dataSettingFile.type.options"
                                ></SelectNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextareaNormal
                                        :label="dataSettingFile.description.label"
                                        :id="dataSettingFile.description.id"
                                        :placeholder="dataSettingFile.description.placeholder"
                                        :value-default="dataSettingFile.description.value"
                                        @inputValue="onChange($event, dataSettingFile.description.id)"
                                        :error-text="dataSettingFile.description.error"
                                        :is-error="dataSettingFile.description.isError"
                                        @blur="validateForm($event, dataSettingFile.description.id)"
                                        :required="dataSettingFile.description.required"
                                ></InputTextareaNormal>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-12 d-flex gap-5">
                                    <div class="col-sm-4 fields-custom">
                                        <label class="col-form-label">Danh sách cột tuỳ chỉnh</label>
                                        <div class="content-custom">
                                            <ul>
                                                <li class="mb-2 mt-1" v-for="(field, key) in fieldsCustom" :key="key">
                                                    <span>{{ field }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 fields-fixed">
                                        <label class="col-form-label">Danh sách cột cố định</label>
                                        <div class="content-fixed">
                                            <ul>
                                                <li class="mb-2 d-flex justify-content-between header" v-if="Object.keys(checkItems).length > 0">
                                                    <div class="name">Chọn tất cả</div>
                                                    <div class="me-1"><InputCheckboxOne id="select_all" :value-default="checkAll" @inputValue="onChangeSelectAll($event)" :checked="checkAll"></InputCheckboxOne></div>
                                                </li>
                                                <li class="mb-2 d-flex justify-content-between item" v-for="(field, key) in fields" :key="key">
                                                    <div class="name">{{ field }}</div>
                                                    <div class="me-1"><InputCheckboxOne :id="key" :value-default="checkItems[key]" @inputValue="onChangeSelectItem($event, key)" :checked="checkItems[key]" :data-ki="checkItems[key]"></InputCheckboxOne></div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <p class="error-text">{{dataSettingFile.fields.error}}</p>
                            </div>
                            <div class="col-sm-2 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSetting" @click="createSettingFile"></ButtonSearchComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
